import { useEffect } from "react";
import { navigate } from "gatsby";

const LANG_PREF_KEY = "koderbox_lang_pref";

const BOT_USER_AGENT_PATTERN =
  /bot|crawl|spider|slurp|googlebot|bingbot|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|linkedinbot|whatsapp|lighthouse|pagespeed/i;

const JapanGeoRedirect = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Respect an explicit choice to stay on the English site.
    if (window.localStorage.getItem(LANG_PREF_KEY) === "en") return;

    // Don't redirect crawlers/bots — a client-side geo-redirect can still
    // catch JS-rendering crawlers, which would hurt indexing of "/".
    if (BOT_USER_AGENT_PATTERN.test(navigator.userAgent)) return;

    let cancelled = false;

    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        if (data && data.country_code === "JP") {
          navigate("/jp/");
        }
      })
      .catch(() => {
        // Fail open — if the geo lookup fails, just stay on the English page.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export const setEnglishLanguagePreference = () => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(LANG_PREF_KEY, "en");
  }
};

export default JapanGeoRedirect;
